/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFamily
 */
export interface APIFamily {
    /**
     * 
     * @type {string}
     * @memberof APIFamily
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIFamily
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIFamily
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIFamily
     */
    name: string;
}

/**
 * Check if a given object implements the APIFamily interface.
 */
export function instanceOfAPIFamily(value: object): value is APIFamily {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIFamilyFromJSON(json: any): APIFamily {
    return APIFamilyFromJSONTyped(json, false);
}

export function APIFamilyFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFamily {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APIFamilyToJSON(value?: Omit<APIFamily, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

